export const addEditStreetValidation = {
  name: [{ required: true, message: 'Street name is required!' }],
  community: [{ required: true, message: 'Community is required!' }],
};
